import React, { useEffect, useState } from 'react'
import { Btn, CustomModal, InputText } from '../../../../components'
import PatrimonioOwnerHttp from '../../../../services/api/https/patrimonio/patrimonio-owner.http'

export default function PatrimonioOwnerModal({ visible, onResponse, selectedOwner }) {
  const [owner, setOwner] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  useEffect(() => {
    if (selectedOwner) {
      setOwner(selectedOwner)
    }
  }, [selectedOwner])

  // Events
  const onBtnSalvarClick = () => {
    if (owner.name.trim().length === 0) {
      onResponse('error', 'Campo Patrimônio Owner incorreto')
    } else {
      setIsLoading(true)
      PatrimonioOwnerHttp.saveOwner(owner)
        .then(savedOwner => {
          onResponse('success', savedOwner)
          setIsLoading(false)
        })
        .catch(error => {
          onResponse('error', error)
          setIsLoading(false)
        })
    }
  }

  //Render
  return (
    <CustomModal
      isVisible={visible}
      onClose={() => onResponse('close')}
      header={owner ? 'Editando Owner' : 'Novo Owner'}
      width={600}
    >
      <div className="p-grid">
        <div className="p-col-8">
          <InputText
            marginTop={0}
            label={'Patrimônio Owner'}
            value={owner ? owner.name : ''}
            onChange={value => setOwner({ ...owner, name: value })}
          />
        </div>
        <div className="p-col-12">
          <Btn isLoading={isLoading} onClick={onBtnSalvarClick}>
            Salvar
          </Btn>
        </div>
      </div>
    </CustomModal>
  )
}
